
import * as echarts from "echarts";
import Vue from "vue";
import { EchartInitModel } from "@/assets/js/Model/InnerModel";
import Utils from "@/assets/js/Utils";
interface dataModel {
  echart: any;
  myChart: any;
}
export default Vue.extend({
  data() {
    return {
      myChart: {} as any,
      colors: [
        [0.25, "#FF6E76"],
        [0.5, "#FDDD60"],
        [0.75, "#58D9F9"],
        [1, "#7CFFB2"],
      ],
    };
  },
  mounted() {
    this.init();
    window.addEventListener("resize", () => {
      this.myChart.resize();
    });
  },
  methods: {
    resize() {
      this.myChart.resize();
    },
    init() {
      const chart: any = this.$refs.chart;
      this.myChart = echarts.init(chart);
    },
    setOptionByAll(opt: any) {
      this.myChart.setOption(opt);
    },
    setOption(data: any, nocolor?: any) {
      const opt = {
        series: [
          {
            type: "gauge",
            startAngle: 180,
            endAngle: 0,
            center: ["50%", data.height],
            radius: data.radius,
            min: 0,
            max: 100,
            splitNumber: 10,
            axisLine: {
              lineStyle: {
                width: 6,
                color: this.colors,
              },
            },
            pointer: {
              length: "12%",
              width: 5,
              offsetCenter: [0, "-60%"],
              itemStyle: {
                color: "auto",
              },
            },
            axisTick: {
              length: 12,
              lineStyle: {
                color: "auto",
                width: 2,
              },
            },
            splitLine: {
              length: 20,
              lineStyle: {
                color: "auto",
                width: 5,
              },
            },
            axisLabel: {
              color: "#464646",
              fontSize: 20,
              distance: -20000,
              rotate: "tangential",
              formatter: function (value: any) {
                return "";
              },
            },
            title: {
              offsetCenter: [0, "-10%"],
              fontSize: 15,
              color: Utils.getTran() ? "#fff" : "#000",
            },
            detail: {
              fontSize: 20,
              offsetCenter: [0, "-35%"],
              valueAnimation: true,
              formatter: function (value: any) {
                return value + "";
              },
              color: "inherit",
            },
            data: data.Data,
          },
        ],
      };
      this.myChart.setOption(opt);
    },
  },
});
